/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2019-01-22 00:25:19
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-24 04:11:17
 */

import _ from "lodash";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "../env/env";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Channel } from "../models/channel.model";
import { TransService } from "./trans.service";

@Injectable()
export class ChannelService {
  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/channels`;

  private _bookmarkChannel: BehaviorSubject<Channel> = new BehaviorSubject(
    null
  );
  private _updatedChannel: BehaviorSubject<Channel> = new BehaviorSubject(null);

  favoriteChannels: Channel[];

  constructor(private transService: TransService, private http: HttpClient) {}

  createChannel(data) {
    return this.http.post(`${this.url}?lang=${this.transService.lang}`, data);
  }

  /**
   * category:
   * search:
   * type: ADMIN, NEWSTAR, FAVORITE, VIEW
   */
  getChannels(page: number, category: string, search: string, type: string) {
    return this.http.get(
      `${this.url}?page=${page}&c=${category || ""}&s=${search ||
        ""}&type=${type || ""}&lang=${this.transService.lang}`
    );
  }

  getChannel(id: string) {
    return this.http.get(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  updateChannel(id: string, data) {
    return this.http.put(
      `${this.url}/${id}?lang=${this.transService.lang}`,
      data
    );
  }

  deleteChannel(id: string) {
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  bookmarkChannel(id: string, enable: boolean) {
    return this.http.put(
      `${this.url}/${id}/bookmark?lang=${this.transService.lang}`,
      {
        enable: enable
      }
    );
  }

  claps(id: string, count: number) {
    return this.http.put(
      `${this.url}/${id}/claps?lang=${this.transService.lang}`,
      {
        count: count
      }
    );
  }

  views(id: string) {
    return this.http.get(
      `${this.url}/${id}/views?lang=${this.transService.lang}`
    );
  }

  notifyBookmarkChannel(celeb: Channel) {
    this._bookmarkChannel.next(celeb);
  }

  get bookmarkedChannel$() {
    return this._bookmarkChannel.asObservable();
  }

  notifyUpdatedChannel(celeb: Channel) {
    this._updatedChannel.next(celeb);
  }

  get updatedChannel$() {
    return this._updatedChannel.asObservable();
  }

  fetchFavortes() {
    return this.getChannels(1, "", "", "FAVORITE").map(res => {
      if (res["payload"]) {
        this.favoriteChannels = res["payload"].docs;
      } else {
        this.favoriteChannels = [];
      }
      return this.favoriteChannels;
    });
  }

  isFavorite(channelId: string) {
    return _.find(this.favoriteChannels, f => f._id === channelId);
  }
}



// WEBPACK FOOTER //
// ./src/services/channel.service.ts